module.exports = __webpack_public_path__ + "img/git.67431914.svg";